// Analog saat widget'ı — Blazor AnalogClockWidget (SVG kadran).
import { useEffect, useState } from 'react';

export function AnalogClockWidget() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const s = now.getSeconds();
  const m = now.getMinutes() + s / 60;
  const h = (now.getHours() % 12) + m / 60;
  const hand = (angle: number, len: number, width: number, color: string) => {
    const rad = ((angle - 90) * Math.PI) / 180;
    return <line x1="50" y1="50" x2={50 + Math.cos(rad) * len} y2={50 + Math.sin(rad) * len} stroke={color} strokeWidth={width} strokeLinecap="round" />;
  };
  return (
    <div className="flex h-full items-center justify-center">
      <svg viewBox="0 0 100 100" className="h-full max-h-48 w-auto" role="img" aria-label={now.toLocaleTimeString('tr-TR')}>
        <circle cx="50" cy="50" r="47" fill="var(--bg-muted)" stroke="var(--border)" strokeWidth="2" />
        {Array.from({ length: 12 }, (_, i) => {
          const rad = ((i * 30 - 90) * Math.PI) / 180;
          return <circle key={i} cx={50 + Math.cos(rad) * 40} cy={50 + Math.sin(rad) * 40} r={i % 3 === 0 ? 2.2 : 1.2} fill="var(--fg-subtle)" />;
        })}
        {hand(h * 30, 24, 4, 'var(--fg)')}
        {hand(m * 6, 33, 3, 'var(--fg)')}
        {hand(s * 6, 37, 1.5, 'var(--color-brand-600, #059669)')}
        <circle cx="50" cy="50" r="2.5" fill="var(--fg)" />
      </svg>
    </div>
  );
}
